import { useRef, useEffect } from 'react';
function isSlideVisible({ itemsPerPage, currentSlide, slideIdx, totalItems, }) {
    const isClonedSlide = currentSlide < 0 || currentSlide >= totalItems;
    const isVisible = slideIdx >= currentSlide && slideIdx < currentSlide + itemsPerPage;
    return isClonedSlide || isVisible;
}
export default function useSlideVisibility({ currentSlide, itemsPerPage, totalItems, }) {
    /** Keeps track of slides that have been visualized before.
     * We want to keep rendering them because the issue is mostly rendering
     * slides that might never be viewed; On the other hand, hiding slides
     * that were visible causes visual glitches */
    const visitedSlides = useRef(new Set());
    useEffect(() => {
        for (let i = 0; i < itemsPerPage; i++) {
            visitedSlides.current.add(currentSlide + i);
        }
    }, [currentSlide, itemsPerPage]);
    const isItemVisible = (index) => isSlideVisible({
        slideIdx: index,
        currentSlide,
        itemsPerPage,
        totalItems,
    });
    const shouldRenderItem = (index) => {
        return visitedSlides.current.has(index) || isItemVisible(index);
    };
    return { shouldRenderItem, isItemVisible };
}
//# sourceMappingURL=useSlideVisibility.js.map